import { render, staticRenderFns } from "./AuthCheck.vue?vue&type=template&id=0d21e9ec&scoped=true&"
import script from "./AuthCheck.vue?vue&type=script&lang=ts&"
export * from "./AuthCheck.vue?vue&type=script&lang=ts&"
import style0 from "./AuthCheck.vue?vue&type=style&index=0&id=0d21e9ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d21e9ec",
  null
  
)

export default component.exports